import styled from 'styled-components';
import { fontSize, fontWeight, formLabel, inputStyles } from 'modules/theme';
import { padding, pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet } from 'modules/v2/foundation/theme';
export const Button = styled.button `
  ${inputStyles};
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: ${pxToRem(200)};
  width: ${(props) => (props.$stretch ? '100%' : 'auto')};
  ${padding(2)};

  &:disabled {
    pointer-events: none;
  }
`;
export const Label = styled.label `
  ${formLabel};
`;
export const Description = styled.div `
  ${fontSize('small')};
  ${fontWeight('normal')};
  color: ${themeGet('colors.gray.700')};
`;
